/** Exponential backoff with symmetric jitter — pure, pinned by test. */

export interface BackoffPolicy {
  readonly baseMs: number;
  readonly factor: number;
  readonly maxMs: number;
  /** ±ratio of the raw delay. */
  readonly jitterRatio: number;
}

export const DEFAULT_BACKOFF: BackoffPolicy = { baseMs: 1000, factor: 2, maxMs: 30_000, jitterRatio: 0.2 };

/** Delay before retry number `attempt` (1-based). `random` ∈ [0,1) injectable for tests. */
export function nextDelay(attempt: number, policy: BackoffPolicy = DEFAULT_BACKOFF, random: () => number = Math.random): number {
  const n = Math.max(1, Math.floor(attempt));
  const raw = Math.min(policy.maxMs, policy.baseMs * policy.factor ** (n - 1));
  const jitter = raw * policy.jitterRatio * (random() * 2 - 1);
  return Math.max(0, Math.round(raw + jitter));
}
